var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductAgencyOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.9%",
    y: "-8.7%",
    width: "121.7%",
    height: "121.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.83625,22.754375 C19.83625,23.2915869 19.4007536,23.7270833 18.8635417,23.7270833 C18.3263297,23.7270833 17.8908333,23.2915869 17.8908333,22.754375 L17.8908333,20.8089583 C17.8908333,19.1973224 16.5843442,17.8908333 14.9727083,17.8908333 L7.19104167,17.8908333 C5.57940573,17.8908333 4.27291667,19.1973224 4.27291667,20.8089583 L4.27291667,22.754375 C4.27291667,23.2915869 3.83742031,23.7270833 3.30020833,23.7270833 C2.76299635,23.7270833 2.3275,23.2915869 2.3275,22.754375 L2.3275,20.8089583 C2.3275,18.1228985 4.50498177,15.9454167 7.19104167,15.9454167 L14.9727083,15.9454167 C17.6587682,15.9454167 19.83625,18.1228985 19.83625,20.8089583 L19.83625,22.754375 Z M11.081875,14 C8.39581511,14 6.21833333,11.8225182 6.21833333,9.13645833 C6.21833333,6.45039844 8.39581511,4.27291667 11.081875,4.27291667 C13.7679348,4.27291667 15.9454167,6.45039844 15.9454167,9.13645833 C15.9454167,11.8225182 13.7679348,14 11.081875,14 Z M11.081875,12.0545833 C12.6935109,12.0545833 14,10.7480943 14,9.13645833 C14,7.5248224 12.6935109,6.21833333 11.081875,6.21833333 C9.47023906,6.21833333 8.16375,7.5248224 8.16375,9.13645833 C8.16375,10.7480943 9.47023906,12.0545833 11.081875,12.0545833 Z M25.6725,22.754375 C25.6725,23.2915869 25.2370036,23.7270833 24.6997917,23.7270833 C24.1625797,23.7270833 23.7270833,23.2915869 23.7270833,22.754375 L23.7270836,20.7665839 C23.7260808,19.3924165 22.8204607,18.1982939 21.5334514,17.8586306 C21.0140246,17.7215451 20.7040757,17.1893367 20.8411611,16.6699098 C20.9782465,16.1504829 21.510455,15.840534 22.0298819,15.9776194 C24.1765307,16.5441561 25.6708574,18.5145289 25.6725,20.7658742 L25.6725,22.754375 Z M17.6416742,6.18588092 C17.1223852,6.04827411 16.8129706,5.51575483 16.9505774,4.99646582 C17.0881842,4.47717681 17.6207035,4.16776226 18.1399925,4.30536907 C20.2885025,4.87470446 21.7816667,6.86559009 21.7816667,9.13645833 C21.7816667,11.4073266 20.2885025,13.3982122 18.1399925,13.9675476 C17.6207035,14.1051544 17.0881842,13.7957399 16.9505774,13.2764508 C16.8129706,12.7571618 17.1223852,12.2246426 17.6416742,12.0870357 C18.9274075,11.7463282 19.83625,10.5345382 19.83625,9.13645833 C19.83625,7.73837848 18.9274075,6.52658844 17.6416742,6.18588092 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Client-Side",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0-1-1-Subscription-Modal",
    transform: "translate(-865.000000, -391.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pricing",
    transform: "translate(845.000000, 393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(23.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#3F51B5",
    strokeWidth: 2,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/ic/users(custom)",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/ic/users(custom)",
    stroke: "none",
    fill: "none",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic/color/primary",
    stroke: "none",
    fill: "none",
    mask: "url(#mask-5)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fill: "#3F51B5",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAgencyOutlined);
export default __webpack_public_path__ + "static/media/product_agency--outlined.a7c8657143ce1b9bf517593eca5b3415.svg";
export { ForwardRef as ReactComponent };